export default __webpack_public_path__ + "static/media/2.2d8b797e.jpg";